// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"42aeabb7","404":"4eda684f","498":"99f0d647"}[chunkId] + ".chunk.js";
};